import { getCoreUtils, nz } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { AppCsvLine } from "./AppCsvLine";
import { AppMoneyEntry, AppMoneyModel } from "./AppMoneyModel";

// AppMoneyCsv - the Revenue items as a CSV file for Excel, built IN THE PAGE from the rows it already holds (no route,
// no service read: the index is the page's own data). The SAME rules `/export` writes by (`ExportRules.Line`): UTF-8
// BOM, RFC 4180 with CRLF, quoted on `"` CR LF or EITHER separator, a `'` before a formula start (CSV injection), the
// separator from the browser's locale (`AppExportRules.SepFor`), never a `sep=` line. Dates are calendar days, so the
// file says which zone "today" (the age column) was counted in.

export class AppMoneyCsv {
    public static readonly Bom: string = "﻿";

    /** The whole file's text. `Sep` "," or ";"; `Zone` names the browser's zone for the age column. */
    public static Text = (Entries: AppMoneyEntry[], Sep: string, Zone: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            let S: string = ",";
            if (Sep === ";") { S = ";"; }
            const Out: string[] = [AppMoneyCsv.Bom + AppMoneyCsv.Line(["Contact", "For", "Note", "Amount", "Currency",
                "Who owes", "Since", "Days open (" + nz(Zone) + ")", "Due", "State", "Settled on", "Source"], S)];
            for (const E of Entries) { Out.push(AppMoneyCsv.Line(AppMoneyCsv.CellsOf(E), S)); }
            return Out.join("");
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMoneyCsv.Text");
            return "";
        }
    };

    private static CellsOf = (E: AppMoneyEntry): string[] => {
        if (getCoreUtils().KErrorMode === true) { return []; }
        try {
            const C: Record<string, string> = AppMoneyModel.Cells(E);
            let State: string = "open";
            if (E.State === "settled") { State = "settled"; }
            let Source: string = "analysis";
            if (E.Source === "you") { Source = "added by you"; }
            if (E.Corrected === true) { Source = Source + ", corrected"; }
            return [E.Contact, E.Label, E.Value, C.Amount, E.Currency, C.Direction, E.Date, C.Age, E.Due, State, E.SettledOn, Source];
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMoneyCsv.CellsOf");
            return [];
        }
    };

    /** One CRLF-terminated line - `ExportRules.Line`'s options exactly. */
    public static Line = (Cells: string[], Sep: string): string => {
        if (getCoreUtils().KErrorMode === true) { return ""; }
        try {
            return AppCsvLine.Line(Cells, Sep);
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, "AppMoneyCsv.Line");
            return "";
        }
    };

    /** "Revenue - 2026-10-14.csv". DOCUMENTED EXCEPTION: pure string. */
    public static FileName = (Today: string): string => {
        return "Revenue - " + nz(Today) + ".csv";
    };
}
